/* La barre des remises du panier, sur tout le site (c28b-panier-barre-partout, 28/10) : snippets/bisou-barre-panier.liquid.
   La même que la barre des Favoris (bisou-alt-simple.js) : les paliers de lot sur une ligne de progression, la phrase
   de ce qu'il manque, le nombre de tirages ; son bouton mène au panier. Elle se montre dès qu'un tirage est au panier,
   se replie par la croix et revient quand le panier change.
   Une seule barre à la fois : elle s'efface sur la page Favoris (leur barre), dans Côte à côte (ses paliers et son
   panier) et au vote (plein écran), devant le rappel d'achat de la fiche (#bisou-rappel-panier), la barre « Achat
   rapide » du téléphone (#bvf-sticky), l'invitation à la communauté (#bvf-nl) et la rangée d'achat de la fiche, et quand le tiroir du panier, le menu ou le
   volet « En savoir plus » est ouvert. */
(function () {
  'use strict';
  var root = document.getElementById('bisou-barre-panier');
  var data = document.getElementById('bcb-donnees');
  if (!root || !data) return;
  var D, CFG = {};
  try { D = JSON.parse(data.textContent); } catch (e) { return; }
  try { CFG = JSON.parse((document.getElementById('bvf-config') || {}).textContent || '{}') || {}; } catch (e) { CFG = {}; }

  var html = document.documentElement;
  var T = D.t || {};
  var OFFER = CFG.offer || {};
  var KEY = 'bcb-replie';
  var preview = !!(window.Shopify && ((window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') || window.Shopify.designMode));
  var carte = root.querySelector('.bcb__carte');
  var head = root.querySelector('.bcb__head');
  var msgEl = root.querySelector('.bcb__msg');
  var nEl = root.querySelector('.bcb__n');
  var rangee = document.querySelector('.bisou-buy-row');
  var nl = document.getElementById('bvf-nl');
  var lastCart = D.cart || null;
  var n = 0, sig = '', steps = null, tiers = [];

  function pct(p) { return String(T.pct || '−[p] %').replace('[p]', p); }
  function isPrint(t) {
    var a = String(CFG.printType || ''), b = String(CFG.printTypeAlt || ''); t = String(t || '');
    return !a || t === a || (!!b && t === b);
  }
  function stored() { try { return window.sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function store(v) { try { if (v == null) window.sessionStorage.removeItem(KEY); else window.sessionStorage.setItem(KEY, v); } catch (e) { /* stockage indisponible */ } }

  /* Les paliers du réglage (p2 à p5), comme la barre des Favoris et le tiroir : seulement si l'offre est en ligne ou en aperçu */
  if (OFFER.live || preview) [2, 3, 4, 5].forEach(function (k) { var p = Number(OFFER['p' + k]) || 0; if (p > 0) tiers.push({ n: k, pct: p }); });
  if (tiers.length) {
    steps = document.createElement('span');
    steps.className = 'bcb__steps';
    if (!OFFER.live && OFFER.preview) steps.title = OFFER.preview;
    tiers.forEach(function (t) {
      var s = document.createElement('span');
      s.className = 'bcb__step';
      s.innerHTML = '<i class="bcb__seg" aria-hidden="true"><i></i></i><b class="bcb__pct"></b><small class="bcb__min"></small>';
      s.querySelector('b').textContent = pct(t.pct);
      s.querySelector('small').textContent = String(T.min || '').replace('[n]', t.n);
      steps.appendChild(s);
    });
    root.querySelector('.bcb__left').appendChild(steps);
    if (!OFFER.live && T.apercu) {
      var ap = document.createElement('span');
      ap.className = 'bcb__apercu';
      ap.textContent = T.apercu;
      head.appendChild(ap);
    }
    root.classList.add('has-steps');
  }

  function paint() {
    nEl.textContent = n === 1 ? (T.one || '') : String(T.many || '').replace('[n]', n);
    if (!steps) { msgEl.textContent = ''; return; }
    var on = null, next = null, lo = 0;
    tiers.forEach(function (t) { if (n >= t.n) on = t; else if (!next) next = t; });
    /* la part de chaque palier se remplit tirage après tirage : à 1 tirage, la moitié de « dès 2 » */
    Array.prototype.forEach.call(steps.children, function (s, i) {
      var t = tiers[i], f = n >= t.n ? 1 : Math.max(0, (n - lo) / (t.n - lo));
      lo = t.n;
      s.style.setProperty('--f', f.toFixed(3));
      s.classList.toggle('is-on', !!on && t.n === on.n);
      s.classList.toggle('is-done', !!on && t.n < on.n);
      s.classList.toggle('is-next', !!next && t.n === next.n);
    });
    msgEl.textContent = next
      ? String(next.n - n === 1 ? T.more_one : T.more_many).replace('[k]', next.n - n).replace('[p]', pct(next.pct))
      : String(T.top || '').replace('[p]', pct(on.pct));
  }

  function lire(cart) {
    lastCart = cart;
    var c = 0, parts = [];
    (cart.items || []).forEach(function (it) {
      if (!isPrint(it.product_type)) return;
      c += it.quantity || 0;
      parts.push(it.key + '×' + it.quantity);
    });
    var nouveau = parts.join(',');
    /* Le panier a changé depuis la croix : la barre revient */
    if (sig && nouveau !== sig && stored() != null) store(null);
    n = c; sig = nouveau;
    if (n > 0) paint();
    maj();
  }

  /* Côte à côte a ses paliers et son « Ajouter au panier » ; le vote est une page plein écran à part : pas de barre */
  function aPart() {
    if (document.getElementById('BRPlanner')) return true;
    var v = document.getElementById('bisou-vote-layer');
    return !!(v && v.getClientRects().length && getComputedStyle(v).visibility !== 'hidden');
  }

  /* Une autre barre en bas, ou un volet ouvert : celle-ci s'efface */
  function cachee() {
    if (html.classList.contains('bvf-off') || html.classList.contains('bvf-s-wish')) return true;
    if (html.classList.contains('bmk-open') || html.classList.contains('bmk7-open') || html.classList.contains('bvf-sticky-on')) return true;
    if (document.body.classList.contains('overflow-hidden')) return true;
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active')) return true;
    var r = document.getElementById('bisou-rappel-panier');
    if (r && r.classList.contains('is-on')) return true;
    /* L'invitation à rejoindre la communauté occupe le même bas d'écran (au téléphone, toute la largeur) */
    if (nl && nl.classList.contains('is-open')) return true;
    /* Fiche tirage : jamais par-dessus « Ajouter au panier » (en 1 280 × 720, la rangée d'achat est tout en bas) */
    if (rangee) {
      var a = rangee.getBoundingClientRect(), vh = window.innerHeight || html.clientHeight;
      var haut = carte.getBoundingClientRect().top - (root.classList.contains('is-on') ? 0 : 14);
      if (a.height && a.top < vh && a.bottom > haut - 8) return true;
    }
    return false;
  }

  /* Aperçu du thème : la barre Shopify passe devant tout en bas ; on se pose au-dessus (comme le rappel d'achat) */
  function lever() {
    var w = document.getElementById('PBarNextFrameWrapper');
    var vh = window.innerHeight || html.clientHeight, lift = 0;
    if (w) { var r = w.getBoundingClientRect(); if (r.height && r.top < vh) lift = Math.round(vh - r.top); }
    root.style.bottom = lift ? lift + 'px' : '';
    html.style.setProperty('--bcb-lift', lift + 'px');
  }
  function hauteur() { var h = carte.offsetHeight; if (h) html.style.setProperty('--bcb-h', h + 'px'); }

  function maj() {
    var la = n > 0 && stored() !== sig && !aPart();
    /* le bas de page garde sa place tant que la barre peut revenir, pour que rien ne saute */
    html.classList.toggle('bcb-room', la);
    var on = la && !cachee();
    /* l'aperçu monte sa pastille « Avant / Après » au-dessus de la barre (bisou-barre-panier.css) */
    html.classList.toggle('bcb-on', on);
    if (on) { lever(); hauteur(); }
    if (on === root.classList.contains('is-on')) return;
    root.classList.toggle('is-on', on);
    if (on) { root.removeAttribute('inert'); root.removeAttribute('aria-hidden'); }
    else {
      if (root.contains(document.activeElement)) document.activeElement.blur();
      root.setAttribute('inert', '');
      root.setAttribute('aria-hidden', 'true');
    }
  }

  root.querySelector('.bcb__x').addEventListener('click', function () { store(sig); maj(); });

  /* Le panier tel que l'annonce l'événement « cart-update » (le panier entier, ou la ligne ajoutée fondue dans le
     dernier panier connu), puis /cart.js corrige tout écart — même façon que bisou-ventes-fidelite.js */
  function fondre(ev) {
    var c = ev && ev.cartData;
    if (!c || c.status) return null;
    if (Array.isArray(c.items) && c.item_count != null) return c;
    if (!lastCart || !c.key || c.quantity == null) return null;
    var items = (lastCart.items || []).slice(), at = -1;
    for (var i = 0; i < items.length; i++) if (items[i].key === c.key) { at = i; break; }
    if (at >= 0) items[at] = c; else items.unshift(c);
    return { items: items, item_count: 0 };
  }
  var t;
  function relire() {
    clearTimeout(t);
    t = setTimeout(function () {
      var base = (window.routes && window.routes.cart_url) || '/cart';
      fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) lire(cart); })
        .catch(function () { /* silencieux */ });
    }, 300);
  }
  if (typeof window.subscribe === 'function') {
    try {
      window.subscribe((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', function (ev) {
        var c = fondre(ev);
        if (c) lire(c);
        relire();
      });
    } catch (e) { /* bus absent */ }
  }
  /* Retour par « Précédent » : la page sort du cache du navigateur, le panier a pu changer ailleurs */
  window.addEventListener('pageshow', function (e) { if (e.persisted) relire(); });

  var mo = window.MutationObserver;
  if (mo) {
    new mo(maj).observe(html, { attributes: true, attributeFilter: ['class'] });
    new mo(maj).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var d = document.querySelector('cart-drawer');
    if (d) new mo(maj).observe(d, { attributes: true, attributeFilter: ['class'] });
    var r = document.getElementById('bisou-rappel-panier');
    if (r) new mo(maj).observe(r, { attributes: true, attributeFilter: ['class'] });
    if (nl) new mo(maj).observe(nl, { attributes: true, attributeFilter: ['class'] });
  }
  if (rangee) {
    var tic = false;
    window.addEventListener('scroll', function () {
      if (tic || !(n > 0)) return;
      tic = true;
      requestAnimationFrame(function () { tic = false; maj(); });
    }, { passive: true });
  }
  if (window.ResizeObserver) new ResizeObserver(hauteur).observe(carte);
  window.addEventListener('resize', function () { if (root.classList.contains('is-on')) lever(); });

  root.setAttribute('inert', '');
  root.setAttribute('aria-hidden', 'true');
  root.removeAttribute('hidden');
  if (lastCart) lire(lastCart);
  /* La barre Shopify de l'aperçu arrive après le chargement */
  if (preview) setTimeout(function () { if (root.classList.contains('is-on')) lever(); }, 1500);
})();
